export default __webpack_public_path__ + "static/media/Liberator's Trinket.9743a176.jpg";